var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMdBuild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.016,
    height: 51.012,
    viewBox: "0 0 51.016 51.012",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-build",
    "data-name": "Icon ionic-md-build",
    d: "M49.616,41.483,29.8,21.534A14.125,14.125,0,0,0,26.528,6.417,14.346,14.346,0,0,0,10.4,3.567l9.364,9.428-6.535,6.578L3.644,10.145a14.208,14.208,0,0,0,2.839,16.21,13.915,13.915,0,0,0,15.031,3.289l19.82,19.949a2.1,2.1,0,0,0,3.053,0L49.4,44.558A1.981,1.981,0,0,0,49.616,41.483Z",
    transform: "translate(-0.736 -0.74)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMdBuild);
export default __webpack_public_path__ + "static/media/icon-md-build.3147a8b70e4c9f0d7a257b3a926022de.svg";
export { ForwardRef as ReactComponent };